import React, { useEffect } from 'react';
import { Button, Card, Form, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import EmployeeForm from '../../components/EmployeeForm';
import { useEmployees } from '../../hooks/useEmployees';
import { useDepartments } from '../../hooks/useDepartments';

const EmployeeCreateView: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { createEmployee, generateEmployeeNumber } = useEmployees();
  const { departments, positions, fetchDepartments, fetchPositions } = useDepartments();

  useEffect(() => {
    fetchDepartments();
    fetchPositions();
    generateEmployeeNumber().then((num) => { if (num) form.setFieldValue('employeeNumber', num); });
  }, []);

  const handleSubmit = async () => {
    const values = await form.validateFields();
    const created = await createEmployee({
      ...values,
      hireDate: values.hireDate?.format('YYYY-MM-DD'),
    });
    if (created) navigate('/hr/employees');
  };

  return (
    <div className="p-6">
      <Card
        title="New Employee"
        extra={
          <Space>
            <Button onClick={() => navigate('/hr/employees')}>Cancel</Button>
            <Button type="primary" onClick={handleSubmit}>Save Employee</Button>
          </Space>
        }
      >
        <EmployeeForm form={form} departments={departments} positions={positions} />
      </Card>
    </div>
  );
};

export default EmployeeCreateView;
